<script setup>
import { ref } from "vue";

const props = defineProps(["format", "modelValue"]);
defineEmits(["update:modelValue"]);

const datePicker = ref(false);

const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang, props.format || { year: "numeric", month: "short", day: "numeric", weekday: "short" });
</script>

<template>
	<div class="vui-date-select">
		<div
			class="select"
			tabindex="0"
			@click="datePicker = true"
			@keydown.space.up.down="datePicker = true"
			@keydown.esc="datePicker = false"
		>
			<i class="fa-regular fa-calendar"></i>
			<div class="date">{{ dateFormat.format(modelValue * 1000) }}</div>
		</div>
		<template v-if="datePicker">
			<UiDatePicker
				:model-value="modelValue"
				class="elevated"
				@update:model-value="$emit('update:modelValue', $event); datePicker = false"
			/>
			<UiBackdrop class="transparent" @close="datePicker = false"/>
		</template>
	</div>
</template>
